import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M21.5 1l-20 20",
                strokeWidth: 2,
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M 4.5 14 H 5.008 L 7.5 11.5 V 11 C 7.5 10.45 7.05 10 6.5 10 H 4.5 C 3.95 10 3.5 10.45 3.5 11 V 13 C 3.5 13.55 3.95 14 4.5 14 Z Z M 4.5 9 H 6.5 C 7.05 9 7.5 8.55 7.5 8 V 6 C 7.5 5.45 7.05 5 6.5 5 H 4.5 C 3.95 5 3.5 5.45 3.5 6 V 8 C 3.5 8.55 3.95 9 4.5 9 Z M 15 14 H 19.5 C 20.05 14 20.5 13.55 20.5 13 V 11 C 20.5 10.45 20.05 10 19.5 10 L 16 10 L 12 14 Z M 9.5 19 H 19.5 C 20.05 19 20.5 18.55 20.5 18 V 16 C 20.5 15.45 20.05 15 19.5 15 L 11 15 L 8.5 17.5 V 18 C 8.5 18.55 8.95 19 9.5 19 Z M 8.5 6 V 8 C 8.5 8.55 8.95 9 9.5 9 L 10 9 L 14 4.991 M 17.011 9.006 H 19.5 C 20.05 9 20.5 8.55 20.5 8 V 6 C 20.496 5.774 20.521 5.701 20.437 5.566 M 14.015 4.991 H 9.5 C 8.95 5 8.5 5.45 8.5 6"
            })
        ]
    }));
};
export default Icon;
